import { render } from "./cpt-radio.vue?vue&type=template&id=98f2a5c4&scoped=true"
import script from "./cpt-radio.vue?vue&type=script&lang=js"
export * from "./cpt-radio.vue?vue&type=script&lang=js"

import "./cpt-radio.vue?vue&type=style&index=0&id=98f2a5c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98f2a5c4"]])

export default __exports__